import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { filter, map, switchMap, take } from "rxjs/operators";
import { loadCurrentUser } from "@/app/stores/auth/auth.actions";
import { selectorCurrentUser, selectorCurrentUserStatus } from "@/app/stores/auth/auth.selectors";
import { ELoadingStatus } from "@/app/core/models/loading-status.model";
import { AuthService } from "@auth0/auth0-angular";

export const firstTimeGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const auth = inject(AuthService);

  return auth.isAuthenticated$.pipe(
    filter((isAuth) => isAuth !== null),
    take(1),
    switchMap((isAuthenticated) => {
      // Not authenticated → allow (AuthGuard on the route will handle redirect to login)
      if (!isAuthenticated) return of(true);

      return store.select(selectorCurrentUserStatus).pipe(
        take(1),
        switchMap((status) => {
          if (status === ELoadingStatus.idle) {
            store.dispatch(loadCurrentUser());
          }

          return store.select(selectorCurrentUserStatus).pipe(
            filter((s) => s === ELoadingStatus.loaded || s === ELoadingStatus.error),
            take(1),
            switchMap(() => store.select(selectorCurrentUser).pipe(take(1)))
          );
        }),
        map((user) => {
          // User is fully set up → redirect away to dashboard
          if (user?.firstName?.trim() && user?.emailVerified) {
            return router.createUrlTree(["/main/projects"]);
          }
          // Still in onboarding flow → allow access
          return true;
        })
      );
    })
  );
};
